import { cookieStorage, createStorage, http, createConfig, type Config } from "wagmi";
import { optimism, optimismSepolia } from "wagmi/chains";
import { injected, walletConnect } from "wagmi/connectors";

const walletConnectProjectId =
  process.env.NEXT_PUBLIC_WALLET_CONNECT_PROJECT_ID || "demo-project-id";

let wagmiConfigInstance: Config | null = null;

/**
 * Creates the wagmi config lazily.
 * Uses injected() instead of metaMask() to avoid MetaMask SDK SSR crashes.
 * The injected() connector auto-detects MetaMask, Rabby, and other injected wallets.
 */
export function getWagmiConfig(): Config {
  if (wagmiConfigInstance) {
    return wagmiConfigInstance;
  }

  wagmiConfigInstance = createConfig({
    chains: [optimism, optimismSepolia],
    ssr: true,
    storage: createStorage({
      storage: cookieStorage,
    }),
    connectors: [
      injected({
        shimDisconnect: true,
      }),
      walletConnect({
        projectId: walletConnectProjectId,
        showQrModal: true,
      }),
    ],
    transports: {
      [optimism.id]: http(),
      [optimismSepolia.id]: http(),
    },
  });

  return wagmiConfigInstance;
}
